import Axios from "axios";

const url = '/itemscore';

const itemScoreApi = {
  getCategoryIds: {
    get: (mfrId) => {
        return Axios.get(`${url + "/category/" + mfrId}`);
    }
  },
  postCategoryIds: {
    post: (params) => {
      return Axios.post(`${url + "/category/platformId/multi"}`, params);
    }
  },
  getSegments: {
    post: (params) => {
      return Axios.post(`${url + "/category/segments"}`, params);
    }
  },
  getOverview: {
    post: (params) => {
        return Axios.post(`${url + "/overview"}`, params);
    }
  },
  getMfrProducts: {
    post: (params) => {
      return Axios.post(`${url + "/comparison/category/products"}`, params);
    }
  },
  getCompProducts: {
    post: (params) => {
      return Axios.post(`${url + "/comparison"}`, params);
    }
  },
  getMarketingProduct: {
    get: (params) => {
      return Axios.get(`${url + "/marketing/product/" + params.productId}`);
    }
  }
};

export default itemScoreApi;
